export default "__VITE_ASSET__BEDN6T4a__ 430w";